// // lib/roles.ts

// export type userRoleCartStreet = 'customer' | 'legal' | 'admin';

// export const ROLES: Record<userRoleCartStreet, userRoleCartStreet> = {
//     customer: 'customer',
//     legal: 'legal',
//     admin: 'admin'
// };

// export const ROLE_ACCESS: Record<userRoleCartStreet, string[]> = {
//     customer: ['/customer', '/dashboard'],
//     legal: ['/customer', '/dashboard'],
//     admin: ['/admin', '/dashboard', '/customer', '/legal']
// };

// export const REDIRECT_URLS: Record<userRoleCartStreet, string> = {
//     customer: '/customer',
//     legal: '/customer',
//     admin: '/admin'
// };

// export const DEFAULT_REDIRECT = '/select-role';

// // نقش‌های معتبر برای اعتبارسنجی
// export const VALID_ROLES: userRoleCartStreet[] = ['customer', 'legal', 'admin'];

// lib/roles.ts

export type userRoleCartStreet =
    | 'customer'
    | 'preCustomer'  // ✅ رول جدید
    | 'legal'
    | 'admin';

export const ROLES: Record<userRoleCartStreet, userRoleCartStreet> = {
    customer: 'customer',
    preCustomer: 'preCustomer',
    legal: 'legal',
    admin: 'admin',
};

export const ROLE_ACCESS: Record<userRoleCartStreet, string[]> = {
    customer: ['/customer', '/dashboard'],
    // ✅ کاربر preCustomer فقط به این مسیرها دسترسی دارد
    preCustomer: [
        '/account-opening',      // صفحه باز کردن حساب
        '/requestCardPage',      // انتخاب طرح
        '/card-request',         // درخواست کارت
        '/regulations',          // قوانین
        '/dashboard',            // داشبورد موقت (اگر دارید)
    ],
    legal: ['/customer', '/dashboard'],
    admin: ['/admin', '/dashboard', '/customer', '/legal'],
};

export const REDIRECT_URLS: Record<userRoleCartStreet, string> = {
    customer: '/customer',
    // ✅ کاربر preCustomer باید برود به صفحه باز کردن حساب
    preCustomer: '/account-opening',
    legal: '/customer',
    admin: '/admin',
};

export const DEFAULT_REDIRECT = '/login';

// نقش‌های معتبر برای اعتبارسنجی
export const VALID_ROLES: userRoleCartStreet[] = [
    'customer',
    'preCustomer',
    'legal',
    'admin',
];